import axios from 'axios'

export const addSubscriberToNewsletter = async ({ email }) => {
  return axios.post('/.netlify/functions/add_subscriber_to_newsletter', {
    email,
  })
}
